import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'device-remove-company',
    templateUrl: './device-remove-company.component.html',
    styleUrls: ['./device-remove-company.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [TranslateModule]
})
export class DeviceRemoveCompanyComponent implements OnInit {

  constructor() { }

  closeAddForm()
  {

  }

  ngOnInit(): void {
  }

}
